import React, { useState, useEffect } from "react";
import {
  StyledTextField,
  StyledDefaultTextField,
  RadioWrapper,
  StyledFormLabel,
  StyledRadioGroup,
  StyledArcher,
  StyledTooltip,
  StyledFormControl,
  StyledSelect,
  AlertContent,
} from "../FuiStyles";
import { RegexStyledTextField } from "../../../helper/utils";
import {
  MenuItem,
  InputLabel,
  Radio,
  Select,
  FormControlLabel,
  DialogContent,
  DialogContentText,
  DialogActions,
  Checkbox,
  CircularProgress,
  FormGroup,
  FormControl,
  FormLabel,
  FormHelperText,
  ListItemText,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import CheckCircle from "@material-ui/icons/CheckCircle";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import { longTextDialogFlow, longTextCustom } from "../Constants/LongText";
import {
  longTextDNS,
  longTextName,
  longTextUser,
  longTextUrl,
  longTextNotes,
  longTextLicenses,
  longTextChooseTheExistingInstance,
  longTextRoot,
  longTextUserManagementGroup,
  longTextAdminDistributionGroup,
  alertPartOne,
  alertPartTwo,
  alertPartThree,
  alertPartFour,
  alertPartFive,
  secondaryContactText,
  longTextOpenAiRegion,
} from "../Constants/LongText";
import { CommonDialog } from "../../common/CommonComponents/Dialog";
import {
  Subtitle3,
  Subtitle5,
  LargeSubtitle,
  FieldName,
  FieldValue
} from "../../common/CommonStyles/CommonTypographyStyles";
import { PrimaryButton } from "../../common/CommonComponents/Buttons";
import { indexOf } from "lodash";
import { Autocomplete } from "@material-ui/lab";
import { StyledTextFieldForm } from "../../ec2management/ServerList/styledServerList";
import base from "../../../config";
import { CancelOutlined, NoEncryption } from "@material-ui/icons";

//Autonomous Ops

//CUI (shared account — TRA / RCA / OID / CMA)
export function AOCuiUrl(handleChange, values) {
  return (
    <StyledTextField
      label="CUI URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.CUIConfig['URL']}
      onChange={(e) => { handleChange(e, "CUIConfig") }}
    />
  );
}
//IM (shared service account — TRA / RCA / OID / CMA)
export function AOImUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Shared Service Account Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.IMConfig['Username']}
      onChange={(e) => handleChange(e, "IMConfig")}
    />
  );
}
export function AOImPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Shared Service Account Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.IMConfig['Password']}
      onChange={(e) => { handleChange(e, "IMConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//KM (TRA only)
export function AOKmUrl(handleChange, values) {
  return (
    <StyledTextField
      label="KM URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.KMConfig['URL']}
      onChange={(e) => { handleChange(e, "KMConfig") }}
    />
  );
}

//Agent Manager (shared — TRA / RCA / OID / CMA)
export function AOAmUrl(handleChange, values) {
  return (
    <StyledTextField
      label="AM URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.AMConfig['URL']}
      onChange={(e) => { handleChange(e, "AMConfig") }}
    />
  );
}
export function AOAmApikey(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="AM API Key"
      id="APIKey"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.AMConfig['APIKey']}
      onChange={(e) => { handleChange(e, "AMConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
export function AOAmType(handleChange, values) {
  return (
    <RadioWrapper>
      <StyledRadioGroup
        aria-label="am-type"
        name="AMType"
        value={values.AMConfig.Type}
        onChange={(e) => handleChange(e, "AMConfig")}
        row
        style={{ marginLeft: '0px' }}
      >
        <FormControlLabel
          checked={values.AMConfig.Type === "onprem"}
          value={"onprem"}
          control={<Radio color="primary" id="Type" />}
          margin="dense"
          label="Onprem"
        />
        <FormControlLabel
          checked={values.AMConfig.Type === "serverless"}
          value={"serverless"}
          margin="dense"
          control={<Radio color="primary" id="Type" />}
          label="Serverless"
          style={{ marginLeft: '20px' }}
        />
      </StyledRadioGroup>
    </RadioWrapper>
  );
}

//Ticket Source (TRA only)
export function AOTsUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Ticket Source URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.TicketSourceConfig['URL']}
      onChange={(e) => { handleChange(e, "TicketSourceConfig") }}
    />
  );
}
export function AOTsUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Ticket Source Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.TicketSourceConfig['Username']}
      onChange={(e) => handleChange(e, "TicketSourceConfig")}
    />
  );
}
export function AOTsPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Ticket Source Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.TicketSourceConfig['Password']}
      onChange={(e) => { handleChange(e, "TicketSourceConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//ServiceNow (basic — shared TRA / RCA / OID / CMA)
export function AOSnUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Service Now URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.ServiceNowConfig['URL']}
      onChange={(e) => { handleChange(e, "ServiceNowConfig") }}
    />
  );
}
export function AOSnUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Service Now Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.ServiceNowConfig['Username']}
      onChange={(e) => handleChange(e, "ServiceNowConfig")}
    />
  );
}
export function AOSnPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Service Now Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.ServiceNowConfig['Password']}
      onChange={(e) => { handleChange(e, "ServiceNowConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Snow MCP extension (RCA only)
export function AOSnowLLMConfig(handleChange, values) {
  return (
    <StyledTextField
      label="Snow LLM Config"
      id="LLMConfig"
      margin="dense"
      variant="outlined"
      value={values.SnowConfig['LLMConfig']}
      onChange={(e) => handleChange(e, "SnowConfig")}
    />
  );
}
export function AOSnowProtocolVersion(handleChange, values) {
  return (
    <StyledTextField
      label="Snow Protocol Version"
      id="ProtocolVersion"
      margin="dense"
      variant="outlined"
      value={values.SnowConfig['ProtocolVersion']}
      onChange={(e) => handleChange(e, "SnowConfig")}
    />
  );
}
export function AOSnowMCPUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Snow MCP URL"
      id="MCPURL"
      margin="dense"
      variant="outlined"
      value={values.SnowConfig['MCPURL']}
      onChange={(e) => { handleChange(e, "SnowConfig") }}
    />
  );
}

//Splunk — RCA uses the MCP fields, OID uses the plain triad; one shared slice
export function AOSplunkLLMConfig(handleChange, values) {
  return (
    <StyledTextField
      label="Splunk LLM Config"
      id="LLMConfig"
      margin="dense"
      variant="outlined"
      value={values.SplunkConfig['LLMConfig']}
      onChange={(e) => handleChange(e, "SplunkConfig")}
    />
  );
}
export function AOSplunkMCPUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Splunk MCP URL"
      id="MCPURL"
      margin="dense"
      variant="outlined"
      value={values.SplunkConfig['MCPURL']}
      onChange={(e) => { handleChange(e, "SplunkConfig") }}
    />
  );
}
export function AOSplunkServiceName(handleChange, values) {
  return (
    <StyledTextField
      label="Splunk Service Name"
      id="ServiceName"
      margin="dense"
      variant="outlined"
      value={values.SplunkConfig['ServiceName']}
      onChange={(e) => handleChange(e, "SplunkConfig")}
    />
  );
}
export function AOSplunkToken(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Splunk Token"
      id="Token"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.SplunkConfig['Token']}
      onChange={(e) => { handleChange(e, "SplunkConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
export function AOSplunkUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Splunk URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.SplunkConfig['URL']}
      onChange={(e) => { handleChange(e, "SplunkConfig") }}
    />
  );
}
export function AOSplunkUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Splunk Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.SplunkConfig['Username']}
      onChange={(e) => handleChange(e, "SplunkConfig")}
    />
  );
}
export function AOSplunkPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Splunk Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.SplunkConfig['Password']}
      onChange={(e) => { handleChange(e, "SplunkConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Build Artifact Storage (shared RCA + OID)
export function AOArtifactS3Bucket(handleChange, values) {
  return (
    <StyledTextField
      label="S3 Bucket"
      id="AWSS3Bucket"
      margin="dense"
      variant="outlined"
      value={values.ArtifactStorage['AWSS3Bucket']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}
export function AOArtifactS3Prefix(handleChange, values) {
  return (
    <StyledTextField
      label="S3 Prefix"
      id="AWSS3Prefix"
      margin="dense"
      variant="outlined"
      value={values.ArtifactStorage['AWSS3Prefix']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}
export function AOArtifactAzStorageAccount(handleChange, values) {
  return (
    <StyledTextField
      label="Azure Storage Account"
      id="AZStorageAccount"
      margin="dense"
      variant="outlined"
      value={values.ArtifactStorage['AZStorageAccount']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}
export function AOArtifactAzContainer(handleChange, values) {
  return (
    <StyledTextField
      label="Azure Storage Container"
      id="AZStorageContainer"
      margin="dense"
      variant="outlined"
      value={values.ArtifactStorage['AZStorageContainer']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}
export function AOArtifactAzPrefix(handleChange, values) {
  return (
    <StyledTextField
      label="Azure Storage Prefix"
      id="AZStoragePrefix"
      margin="dense"
      variant="outlined"
      value={values.ArtifactStorage['AZStoragePrefix']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}
export function AOArtifactUpload(handleChange, values) {
  return (
    <StyledTextField
      label="Upload Artifact"
      id="UploadArtifact"
      margin="dense"
      variant="outlined"
      helperText="true / false"
      value={values.ArtifactStorage['UploadArtifact']}
      onChange={(e) => handleChange(e, "ArtifactStorage")}
    />
  );
}

//CMDBLite (OID only)
export function AOCmdbUrl(handleChange, values) {
  return (
    <StyledTextField
      label="CMDBLite URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.CMDBLiteConfig['URL']}
      onChange={(e) => { handleChange(e, "CMDBLiteConfig") }}
    />
  );
}
export function AOCmdbUsername(handleChange, values) {
  return (
    <StyledTextField
      label="CMDBLite Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.CMDBLiteConfig['Username']}
      onChange={(e) => handleChange(e, "CMDBLiteConfig")}
    />
  );
}
export function AOCmdbPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="CMDBLite Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.CMDBLiteConfig['Password']}
      onChange={(e) => { handleChange(e, "CMDBLiteConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Datadog (OID only)
export function AODatadogUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Datadog URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.DatadogConfig['URL']}
      onChange={(e) => { handleChange(e, "DatadogConfig") }}
    />
  );
}
export function AODatadogUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Datadog Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.DatadogConfig['Username']}
      onChange={(e) => handleChange(e, "DatadogConfig")}
    />
  );
}
export function AODatadogPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Datadog Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.DatadogConfig['Password']}
      onChange={(e) => { handleChange(e, "DatadogConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Dynatrace (OID only)
export function AODynatraceUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Dynatrace URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.DynatraceConfig['URL']}
      onChange={(e) => { handleChange(e, "DynatraceConfig") }}
    />
  );
}
export function AODynatraceUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Dynatrace Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.DynatraceConfig['Username']}
      onChange={(e) => handleChange(e, "DynatraceConfig")}
    />
  );
}
export function AODynatracePassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Dynatrace Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.DynatraceConfig['Password']}
      onChange={(e) => { handleChange(e, "DynatraceConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Elasticsearch (OID only)
export function AOElasticUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Elastic Search URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.ElasticSearchConfig['URL']}
      onChange={(e) => { handleChange(e, "ElasticSearchConfig") }}
    />
  );
}
export function AOElasticUsername(handleChange, values) {
  return (
    <StyledTextField
      label="Elastic Search Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.ElasticSearchConfig['Username']}
      onChange={(e) => handleChange(e, "ElasticSearchConfig")}
    />
  );
}
export function AOElasticPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Elastic Search Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.ElasticSearchConfig['Password']}
      onChange={(e) => { handleChange(e, "ElasticSearchConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//OID source selection (OID only)
export function AOOidSources(handleChange, values) {
  return (
    <StyledTextField
      label="OID Sources"
      id="Sources"
      margin="dense"
      variant="outlined"
      helperText="Comma-separated list of observability sources to onboard (e.g. Datadog,Dynatrace,Elasticsearch)"
      value={values.OIDConfig['Sources']}
      onChange={(e) => handleChange(e, "OIDConfig")}
    />
  );
}

//SLO (OID only)
export function AOSloUrl(handleChange, values) {
  return (
    <StyledTextField
      label="SLO URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.SLOConfig['URL']}
      onChange={(e) => { handleChange(e, "SLOConfig") }}
    />
  );
}
export function AOSloUsername(handleChange, values) {
  return (
    <StyledTextField
      label="SLO Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.SLOConfig['Username']}
      onChange={(e) => handleChange(e, "SLOConfig")}
    />
  );
}
export function AOSloPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="SLO Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.SLOConfig['Password']}
      onChange={(e) => { handleChange(e, "SLOConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//Venafi (CMA only)
export function AOVenafiUrl(handleChange, values) {
  return (
    <StyledTextField
      label="Venafi URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.VenafiConfig['URL']}
      onChange={(e) => { handleChange(e, "VenafiConfig") }}
    />
  );
}
export function AOVenafiApikey(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="Venafi API Key"
      id="APIKey"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.VenafiConfig['APIKey']}
      onChange={(e) => { handleChange(e, "VenafiConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

//AWX / Ansible (CMA only)
export function AOAwxUrl(handleChange, values) {
  return (
    <StyledTextField
      label="AWX URL / Endpoint"
      id="URL"
      margin="dense"
      variant="outlined"
      value={values.AWXConfig['URL']}
      onChange={(e) => { handleChange(e, "AWXConfig") }}
    />
  );
}
export function AOAwxUsername(handleChange, values) {
  return (
    <StyledTextField
      label="AWX Username"
      id="Username"
      margin="dense"
      variant="outlined"
      value={values.AWXConfig['Username']}
      onChange={(e) => handleChange(e, "AWXConfig")}
    />
  );
}
export function AOAwxPassword(handleChange, values, showPassword, handleShowPassword) {
  return (
    <StyledTextField
      label="AWX Password"
      id="Password"
      margin="dense"
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={values.AWXConfig['Password']}
      onChange={(e) => { handleChange(e, "AWXConfig") }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={(e) => handleShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
export function AOAwxJobTemplateId(handleChange, values) {
  return (
    <StyledTextField
      label="AWX Job Template ID (Optional)"
      id="JobTemplateID"
      margin="dense"
      variant="outlined"
      value={values.AWXConfig['JobTemplateID']}
      onChange={(e) => handleChange(e, "AWXConfig")}
    />
  );
}
export function AOAwxTargetHost(handleChange, values) {
  return (
    <StyledTextField
      label="AWX Target Host (Optional)"
      id="TargetHost"
      margin="dense"
      variant="outlined"
      value={values.AWXConfig['TargetHost']}
      onChange={(e) => handleChange(e, "AWXConfig")}
    />
  );
}
export function AOAwxTargetUser(handleChange, values) {
  return (
    <StyledTextField
      label="AWX Target User (Optional)"
      id="TargetUser"
      margin="dense"
      variant="outlined"
      value={values.AWXConfig['TargetUser']}
      onChange={(e) => handleChange(e, "AWXConfig")}
    />
  );
}
export function AOAwxTimeout(handleChange, values) {
  return (
    <StyledTextField
      label="AWX Timeout (Optional)"
      id="Timeout"
      margin="dense"
      variant="outlined"
      helperText="Seconds"
      value={values.AWXConfig['Timeout']}
      onChange={(e) => handleChange(e, "AWXConfig")}
    />
  );
}

//RCA-specific fields (unchanged object key "RCA")
export function AOAgentCollection(handleChange, values) {
  return (
    <StyledTextField
      label="Agent Collection"
      id="AgentCollection"
      margin="dense"
      variant="outlined"
      value={values.RCA['AgentCollection']}
      onChange={(e) => handleChange(e, "RCA")}
    />
  );
}
export function AOConfigSource(handleChange, values) {
  return (
    <StyledTextField
      label="Config Source"
      id="ConfigSource"
      margin="dense"
      variant="outlined"
      value={values.RCA['ConfigSource']}
      onChange={(e) => handleChange(e, "RCA")}
    />
  );
}
export function AORCATeamId(handleChange, values) {
  return (
    <StyledTextField
      label="RCA Team ID"
      id="RCATeamID"
      margin="dense"
      variant="outlined"
      value={values.RCA['RCATeamID']}
      onChange={(e) => handleChange(e, "RCA")}
    />
  );
}
export function AOAmWorkSpaceId(handleChange, values) {
  // AMConfig doesn't carry a Workspace ID in the current payload shape
  // (AMConfig = URL / APIKey / Type only), so this lives under the
  // RCA-specific config instead.
  return (
    <StyledTextField
      label="AM Workspace ID"
      id="WorkspaceID"
      margin="dense"
      variant="outlined"
      value={values.RCA['WorkspaceID']}
      onChange={(e) => handleChange(e, "RCA")}
    />
  );
}
export function AODomainContextRoot(handleChange, values) {
  return (
    <StyledTextField
      label="Domain Context Root"
      id="DomainContextRoot"
      margin="dense"
      variant="outlined"
      value={values.DomainContextRoot}
      onChange={(e) => handleChange(e, "DomainContextRoot")}
    />
  );
}